import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { Screens } from '~/constants/config/permissions';
import { CatalogPageSkeleton } from '~/features/content/components/catalog/catalog-page-skeleton';
import { QcFullPage } from '~/features/content/components/qc/qc-full-page';
import { requirePermission } from '~/utils/guards';

const CatalogSetupPage = lazy(() => import('~/features/content/pages/catalog-setup-page'));

/**
 * Optional prefill: "Change setup" / "Run again" from a catalog run fills the form with its
 * settings and products; from a QC check (`-qc`), with its settings only.
 */
const searchSchema = z.object({
  fromRun: z.string().max(200).optional().catch(undefined),
});

/** Catalog run step 1 — Set up a new catalog run, at `/content/catalog/new` — a full page outside the Content tabs. */
export const Route = createFileRoute('/_authenticated/_tenant/content_/catalog/new')({
  // Outside the Content layout (its own full page), so it repeats the section's screen guard.
  beforeLoad: requirePermission(Screens.CONTENT_GENERATION),
  validateSearch: searchSchema,
  component: CatalogSetupRoute,
});

function CatalogSetupRoute() {
  const { fromRun } = Route.useSearch();
  return (
    <QcFullPage>
      <Suspense fallback={<CatalogPageSkeleton />}>
        {/* Keyed by the source run, so moving to another `fromRun` starts a fresh setup. */}
        <CatalogSetupPage key={fromRun ?? ''} fromRun={fromRun} />
      </Suspense>
    </QcFullPage>
  );
}
